<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
  >
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item v-if="formItemKey == 'buyerRemarks'" label="" prop="buyerRemarks">
        <BjInput
          v-model="form.buyerRemarks"
          type="textarea"
          :placeholder="$t('OrdinaryOrderMix.EditRemarks.buyer')"
          :maxlength="MAX_LENGTH.PRIORITY"
          show-word-limit
          clearable
          rows="5"
          required
        ></BjInput>
      </el-form-item>
      <el-form-item v-if="formItemKey == 'orderRemarks'" label="" prop="orderRemarks">
        <BjInput
          v-model="form.orderRemarks"
          type="textarea"
          :placeholder="$t('OrdinaryOrderMix.EditRemarks.merchant')"
          :maxlength="MAX_LENGTH.PRIORITY"
          show-word-limit
          clearable
          rows="5"
          required
        ></BjInput>
      </el-form-item>
      <el-form-item v-if="formItemKey == 'serviceRemarks'" label="" prop="serviceRemarks">
        <BjInput
          v-model="form.serviceRemarks"
          type="textarea"
          :placeholder="$t('OrdinaryOrderMix.EditRemarks.customer')"
          :maxlength="MAX_LENGTH.PRIORITY"
          show-word-limit
          clearable
          rows="5"
          required
        ></BjInput>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirmEditRemarks">{{ $t('okText') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'BusinessOrderInternalViewFormEditRemarks',
  props: {
    id: {
      type: String,
      default: null,
    },
    info: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      titles: {
        buyerRemarks: this.$t('InternalSalesOrderDetails.Buyer'),
        orderRemarks: this.$t('InternalSalesOrderDetails.Merchant'),
        serviceRemarks: this.$t('InternalSalesOrderDetails.Customer'),
      },

      formItemKey: null,
      // 弹窗显示
      dialogVisible: false,

      form: {
        orderId: null,
        buyerRemarks: null,
        orderRemarks: null,
        serviceRemarks: null,
      },
      rules: {
        // buyerRemarks: [{ required: true, message: '请输入买家备注', trigger: 'blur' }],
        // orderRemarks: [{ required: true, message: '请输入商家备注', trigger: 'blur' }],
        // serviceRemarks: [{ required: true, message: '请输入客服备注', trigger: 'blur' }],
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.$t('OrdinaryOrderMix.EditRemarks.Modify') + this.titles[this.formItemKey];
    }
  },
  methods: {
    // 修改备注
    onEdit(key) {
      this.formItemKey = key;
      this.dialogVisible = true;
      this.form = {
        orderId: this.id,

        buyerRemarks: this.info.buyerRemarks,
        orderRemarks: this.info.orderRemarks,
        serviceRemarks: this.info.serviceRemarks,
      };
    },
    confirmEditRemarks() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('editBaseInfoApi', this.form);
        } else {
          return false;
        }
      });
    },
  },
};
</script>
